module.exports = __webpack_public_path__ + "static/media/trim-ped-t.953bc5f4.png";